import { render, staticRenderFns } from "./ManageModule.vue?vue&type=template&id=811d2662"
import script from "./ManageModule.vue?vue&type=script&lang=ts"
export * from "./ManageModule.vue?vue&type=script&lang=ts"
import style0 from "./ManageModule.vue?vue&type=style&index=0&id=811d2662&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports